var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topTip"},[_c('div',{staticClass:"mainText"},[_vm._v(_vm._s(_vm.mainText))])])}
var staticRenderFns = []

export { render, staticRenderFns }